import { toInstallationHealth } from "@/domain/integration"
import { isRecord } from "@/helpers/utils"

import type { TicketingSystem } from "@/domain/ticketing"
import type { TicketingNotificationSettings } from "."

export const toNotificationSettings = (
  settings?: Partial<TicketingNotificationSettings>
): TicketingNotificationSettings => ({
  commentOnResolved: settings?.commentOnResolved ?? false,
  commentOnDismissed: settings?.commentOnDismissed ?? false,
  commentOnUndismissed: settings?.commentOnUndismissed ?? false,
  commentOnRiskChange: settings?.commentOnRiskChange ?? false,
  labelOnResolved: settings?.labelOnResolved ?? false,
  labelOnDismissed: settings?.labelOnDismissed ?? false,
  labelOnUndismissed: settings?.labelOnUndismissed ?? false
})

const getEntry = (record: unknown, key: string) =>
  isRecord(record) ? record[key] : undefined

const getString = (record: unknown, key: string) => {
  const value = getEntry(record, key)

  return typeof value === "string" && value ? value : undefined
}

const getBoolean = (record: unknown, key: string) => {
  const value = getEntry(record, key)

  return typeof value === "boolean" ? value : undefined
}

// Jira, Azure Boards and Asana describe the same settings; account is the Azure DevOps
// organization or Asana workspace
export const getTicketingSettings = (
  configuration: unknown,
  vendor: TicketingSystem
) => {
  const settings = getEntry(configuration, "notificationSettings")

  return {
    id: getString(configuration, "id") ?? `${vendor}-settings`,
    name: getString(configuration, "name") ?? vendor,
    account: getString(configuration, "account"),
    health: toInstallationHealth(getEntry(configuration, "health")),
    notificationSettings: toNotificationSettings({
      commentOnResolved: getBoolean(settings, "commentOnResolved"),
      commentOnDismissed: getBoolean(settings, "commentOnDismissed"),
      commentOnUndismissed: getBoolean(settings, "commentOnUndismissed"),
      commentOnRiskChange: getBoolean(settings, "commentOnRiskChange"),
      labelOnResolved: getBoolean(settings, "labelOnResolved"),
      labelOnDismissed: getBoolean(settings, "labelOnDismissed"),
      labelOnUndismissed: getBoolean(settings, "labelOnUndismissed")
    })
  }
}
